"use strict";
/* globals module */
/**
 * @module commerceCustomerClient
 * @description  Commerce Customer Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceCustomerClient` uses `commerceCustomerRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../httpApi");
var __1 = require("../");
var CommerceCustomerClient = /** @class */ (function () {
    function CommerceCustomerClient(commerceCustomerPaymentMethodClient, commerceCustomerRoute, apiClient) {
        this.commerceCustomerPaymentMethodClient = commerceCustomerPaymentMethodClient;
        this.commerceCustomerRoute = commerceCustomerRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceCustomerClient.prototype, "paymentMethods", {
        get: function () {
            return this.commerceCustomerPaymentMethodClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceCustomerClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceCustomerRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceCustomerClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceCustomerClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceCustomerClient.get(id)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceCustomerClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceCustomerRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceCustomerRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = apiClient.removeParams(commerceCustomer);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceCustomer is a resource previously fetched using get action.
                    commerceCustomer.isDefault : true;
                    commerceCustomerClient.update(commerceCustomer)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceCustomerClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceCustomerRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = apiClient.removeParams(commerceCustomer);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceCustomer is a resource previously fetched using get action.
                    commerceCustomerClient.remove(commerceCustomer)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceCustomerClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceCustomerClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceCustomerPaymentMethodClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceCustomerRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceCustomerPaymentMethodClient !== "undefined" && __1.CommerceCustomerPaymentMethodClient) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceCustomerRoute !== "undefined" && __1.CommerceCustomerRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceCustomerClient);
    return CommerceCustomerClient;
}());
exports.CommerceCustomerClient = CommerceCustomerClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
